export default {
  ended: {
    title: {
      en: 'Bets are not accepted',
    },
    text: {
      en: 'The event being viewed has been completed or is no longer available',
    },
  },
  empty: {
    live: {
      title: {
        en: 'Live markets not available for this event',
      },
      text: {
        en: 'Unfortunately, there are no live markets available for this match. You can choose another football event that is live right now.',
      },
    },
    prematch: {
      title: {
        en: 'Markets not available for this event',
      },
      text: {
        en: 'Unfortunately, there are no markets available for this match.',
      },
    },
  },
  livePending: {
    title: {
      en: 'Live status: Information pending',
    },
    text: {
      en: 'We are awaiting information on the availability of live markets for this match. Estimated waiting time <span class="text-accent-grey-30">{time}</span>',
    },
  },
}
